import { BarChart, Bar, XAxis, YAxis, Cell, ResponsiveContainer, LabelProps } from 'recharts';
import { theme } from 'twin.macro';

type TickProps = {
  x?: number;
  y?: number;
  payload?: { value: string };
};

export type BrandSafetyChartData = {
  name: string;
  value: number;
  fill: string;
  count?: number;
};

type BrandSafetyBarChartProps = {
  data: BrandSafetyChartData[];
  margin?: { top?: number; right?: number; left?: number; bottom?: number };
  height?: number;
};

function Label(props: LabelProps) {
  const { x, y, width, value } = props;
  const numberX = Number(x);
  const numberY = Number(y);
  const numberWidth = Number(width);
  const numberValue = Number(value);
  if (isNaN(numberX) || isNaN(numberY) || isNaN(numberWidth) || isNaN(numberValue)) return null;

  return (
    <text
      // if the value is more than 93 (93 percent), then the text should be on the left side of the bar because it will be out of the bar
      x={numberX + numberWidth + (Math.ceil(numberValue) < 93 ? 30 : -30)}
      y={numberY + 10}
      fill={
        Math.ceil(numberValue) < 93
          ? theme`colors.text-and-icon-muted`
          : theme`colors.text-and-icon-invert`
      }
      textAnchor='middle'
      dominantBaseline='middle'>
      {numberValue.toFixed(1)}%
    </text>
  );
}

const Tick = ({ y, payload }: TickProps) => {
  return (
    <text
      tw=''
      x={0}
      y={0}
      dx={0}
      dy={y}
      textAnchor='start'
      fontSize={12}
      fill={theme`colors.text-and-icon`}>
      {payload?.value}
    </text>
  );
};

export const BrandSafetyBarChart = ({ data, margin, height }: BrandSafetyBarChartProps) => (
  <ResponsiveContainer width='100%' height={height || 120}>
    <BarChart data={data} layout='vertical' margin={margin}>
      <XAxis type='number' hide domain={[0, 100]} />
      <YAxis
        type='category'
        dataKey='name'
        tickLine={false}
        axisLine={false}
        tick={<Tick />}
        interval={0}
      />
      <Bar
        dataKey='value'
        label={<Label />}
        barSize={18}
        background={{ fill: theme`colors.gray-2` }}
        radius={2}>
        {data.map((entry, index) => (
          <Cell key={`cell-${index}`} fill={entry.fill} />
        ))}
      </Bar>
    </BarChart>
  </ResponsiveContainer>
);
